<div
	class="over-menu pos-rel fl-adaptable w-100"
	style="pointer-events: none; z-index: 0; margin-bottom: -10px"
>
	<ng-content select="[~bg]"></ng-content>
</div>

<div
	class="menu ov-h border-230-t border-box w-100 fl fl-dir-c fl-ai-st fl-jc-fs shadow-z2"
	[class.bg-280]="!lightBg"
	[class.bg-180]="lightBg"
	style="z-index: 1"
	#menu
	(click)="stopEvent($event)"
	(transitionend)="onTransitionEnd($event)"
>
	@if (showHeader) {
		<div class="fl-fixed w-100 p-2-rl border-box">
			<div
				class="header fl-fixed w-100 fl fl-jc-fs fl-ai-c"
				[reachPan]="reachPanActive"
				(reachPanMove)="panMove($event)"
				(reachPanFinish)="panFinish($event)"
				(reachPanCancel)="panCancel()"
			>
				<div #leftOption class="option left fl-fixed fl fl-jc-fs fl-ai-c">
					<ng-content select="[~left]"></ng-content>
				</div>
				<div
					class="title fl-adaptable p-2-rl border-box fl fl-ai-c fl-jc-c fs-l fc-800 fw-bold ellipsis talign-c"
				>
					<ng-content select="[~title]"></ng-content>
				</div>
				<div #rightOption class="option right fl-fixed fl fl-jc-fe fl-ai-c">
					<ng-content select="[~right]"></ng-content>
				</div>
			</div>
		</div>
	}

	<ng-content select="[~over-content]"></ng-content>

	<div
		class="pos-rel content fl-adaptable w-100 ov-auto fl fl-dir-col fl-ai-st fl-jc-fs"
		cdkScrollable
	>
		<div
			class="content-wrapper border-box ov-auto"
			[class.p-1-rl]="lightBg"
			[class.bg-190]="darkBg"
		>
			<ng-content></ng-content>
		</div>
	</div>
	@if (showFooter) {
		<ng-content select="[~footer]"></ng-content>
	}
</div>
